var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('div',{ref:"banner",staticClass:"banner-inner",class:_vm.backgroundClasses,style:(("" + _vm.backgroundImgStyle))})])}
var staticRenderFns = []

export { render, staticRenderFns }